var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1.041 1.082)"},React.createElement("path",{"d":"M1517.326,4158.156l-5.951,6.184,22.658,23.5,22.655-23.5-5.951-6.184-16.705,17.362Z","transform":"translate(-1511.375 -4158.156)","fill":"none","stroke":"#000","strokeMiterlimit":"10","strokeWidth":"1.5"})));
}

Down.defaultProps = {"width":"47.396","height":"31.851","viewBox":"0 0 47.396 31.851"};

module.exports = Down;

Down.default = Down;
